export * from './getDashboardAnalyticsDetail.query';
